import { render, staticRenderFns } from "./orderStatics.vue?vue&type=template&id=d60aa76e&"
import script from "./orderStatics.vue?vue&type=script&lang=js&"
export * from "./orderStatics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports